import React from 'react';
import Icon from '../app_components/Icon';
import { semantic, primitives } from '@lexody/design-tokens';
import { usesDashFormVariant } from '../../utils/formVariant';
import { iconColorForTone } from './morphismIconColors';

const DASH_ICON_COLORS = {
  purple: primitives.violet['500'],
  violet: primitives.violet['500'],
  blue: primitives.blue['500'],
  orange: primitives.orange['500'],
  coral: primitives.pink['500'],
  teal: primitives.green['500'],
  green: primitives.green['500'],
  pink: primitives.pink['500'],
  grey: semantic.greyscale.text.subtitle,
};

function dashIconColor(tone) {
  return DASH_ICON_COLORS[tone] || DASH_ICON_COLORS.purple;
}

class SettingsTextInput extends React.Component {
  renderGameyField() {
    const {
      label,
      attribute,
      value,
      onChange,
      placeholder,
      icon = 'edit',
      tone = 'purple',
      hint,
      inputError,
    } = this.props;

    return (
      <div className={`lex-dash-field lex-dash-field--${tone}`}>
        {label && <label className="lex-dash-field__label">{label}</label>}
        <div className="lex-dash-field__inputWrap">
          <input
            className="lex-dash-field__input"
            onChange={(event) => onChange(event.target.value, attribute)}
            value={value || ''}
            placeholder={placeholder}
          />
          <span className="lex-dash-field__icon" aria-hidden="true">
            <Icon name={icon} size={16} color={dashIconColor(tone)} solid />
          </span>
        </div>
        {hint && <p className="lex-dash-field__hint">{hint}</p>}
        {inputError && <p className="lex-dash-field__error">{inputError}</p>}
      </div>
    );
  }

  render() {
    const {
      label,
      attribute,
      value,
      onChange,
      placeholder,
      icon = 'edit',
      tone = 'blue',
      hint,
      inputError,
      variant,
    } = this.props;

    if (usesDashFormVariant(variant)) {
      return this.renderGameyField();
    }

    return (
      <div className="lex-field">
        {label && <p className="lex-field__label">{label}</p>}
        {hint && <p className="lex-field__hint">{hint}</p>}
        {inputError && <p className="lex-field__error">{inputError}</p>}
        <div className={`lex-input lex-input--${tone}`}>
          <span className="lex-input__icon" aria-hidden="true">
            <Icon name={icon} size={18} color={iconColorForTone(tone)} />
          </span>
          <input
            className="lex-input__control"
            onChange={(event) => onChange(event.target.value, attribute)}
            value={value || ''}
            placeholder={placeholder}
          />
        </div>
      </div>
    );
  }
}

export default SettingsTextInput;
